import React from 'react'
import { clsx } from 'clsx'

export const Notifications = ({ data }: { data: any }) => {
  return (
    <div className="-mt-[270px] notification-cards px-3">
      {data?.items?.map((el: any, i: number) => {
        let background =
          'linear-gradient(180deg, rgba(215, 65, 42, 0.06) 0%, rgba(215, 65, 42, 0.02) 100%)'
        if (i === 1) {
          background =
            'linear-gradient(180deg, rgba(215, 162, 19, 0.08) 0%, rgba(215, 162, 19, 0.04) 100%)'
        } else if (i === 2) {
          background =
            'linear-gradient(180deg, rgba(255, 115, 0, 0.06) 0%, rgba(255, 115, 0, 0.02) 100%)'
        }
        return (
          <div
            key={i}
            className={clsx(
              { wef: true },
              'rounded-button font-semibold flex p-4 border-0 mt-2 whitespace-normal text-left border-buttonGradient justify-start gap-4 text-text relative transition-all duration-200',
            )}
            style={{ backgroundImage: background }}
          >
            {el.icon && (
              <img src={el.icon} className="h-fit" alt={el.title} width={40} height={40} />
            )}
            <div className="grow">
              {el.title}
              <p className="font-medium text-[12px] leading-[16px] text-[#101A3699]">
                {el?.description && el?.description}
              </p>
            </div>
            {el?.time && (
              <span className="block font-medium text-[12px] text-[#101A3666] text-end">
                {el?.time}
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}
